import React from 'react';
import type { Opportunity } from '../../types';

export function VacancyAnalytics({ opportunity }: { opportunity: Opportunity }) {
  const items = [
    opportunity.vacancies != null ? { label: 'Vacancies', value: opportunity.vacancies.toLocaleString('en-IN') } : null,
    opportunity.postsCount != null ? { label: 'Posts', value: opportunity.postsCount.toLocaleString('en-IN') } : null,
    opportunity.departmentsCount != null ? { label: 'Departments', value: String(opportunity.departmentsCount) } : null,
  ].filter(Boolean) as Array<{ label: string; value: string }>;

  if (items.length === 0) return null;

  return (
    <div className="wfx-opp-vacancy-analytics glass-surface">
      <h3>Vacancy analytics</h3>
      <div className="wfx-opp-vacancy-grid">
        {items.map((item) => (
          <div key={item.label}>
            <span className="wfx-muted">{item.label}</span>
            <strong>{item.value}</strong>
          </div>
        ))}
      </div>
    </div>
  );
}
